import { ActivatedRoute } from '@angular/router';
import { Component, OnDestroy } from '@angular/core';
import { environment } from '../environments/environment';
import { LangService, SupportedLanguage } from './services/lang.service';
import { LANGUAGE_PARAMETER } from './commons/constants';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnDestroy {
  title = 'SRP Zuid Configurator';

  private subscription?: Subscription;

  constructor(
    private readonly titleService: Title,
    private readonly translateService: TranslateService,
    private readonly route: ActivatedRoute,
    private readonly langService: LangService
  ) {
    this.titleService.setTitle(environment.title);

    const supportedLanguages = this.langService.getSupportedLanguages();
    const defaultLanguage = this.langService.getDefaultLanguage();
    
    this.subscription = this.route.queryParamMap.subscribe(params => {
      let langParam = params.get(LANGUAGE_PARAMETER);
      if (langParam) {
        langParam = langParam.trim().toLowerCase();
      }
      const lang = langParam as SupportedLanguage;
      const chosenLang = (lang && supportedLanguages.includes(lang))
        ? lang
        : defaultLanguage;

      this.translateService.use(chosenLang);
      this.langService.setLanguage(chosenLang);
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
